const answers = [
  'Except as required to fulfill the credit obligations set forth above (if any), no Party shall use or' +
    ' employ the names, likeness, marks, logos, or biographical information of any other Party' +
    ' without the prior, written permission of such Party.',

  'The Parties shall be authorized to use or employ the names, likeness, marks, logos, or' +
    ' biographical information (the “Materials”) of any other Party, provided such uses are in' +
    ' connection with the sale, exploitation, license, or promotion of the Work.',
];

export default (options) => {
  let content = answers[options.field1];

  return {
    content,
    checked: true,
  };
};



// WEBPACK FOOTER //
// src/components/ContractBlock/Contents/NameLikeness.js